var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('navigation',{attrs:{"color":_vm.color,"flat":_vm.flat}}),_c('v-main',{staticClass:"pt-0 pt-15"},[_c('div',{staticClass:"pt-5"},[_c('div',{attrs:{"id":"redoc-container"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }